import React from 'react';
import FolderSvg from "../../Images/folder.svg"
import "./styles.css"

const CourseMaterial = ({ lessonData }) => {

    return (
        <div>
            <div className="course-container">
                <h2 className="lesson-title">{lessonData.title}</h2>
                <div className="video-container">
                    <video className='thumbnail' controls>
                        <source src={lessonData.videoUrl} type="video/mp4" />
                        Your browser does not support the video tag.
                    </video>
                </div>
                <div className='content-container'>
                    <h3 className="materials-title">Written materials for the lesson:</h3>
                    <p className="description">{lessonData.description}</p>
                    <div className="file-section">
                        <span className="file-label">Download the file</span>
                        <div className='uploaded-file-container'>
                            <img src={FolderSvg} alt="" />
                            <a href={lessonData.file.fileURL} target="_blank" rel="noopener noreferrer">
                                {lessonData.file.fileName}
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            <div className='feedback-container'>
                <span className='feedback-title'>Explanation of errors</span>
                <div className='feedback-comment'>
                    <textarea
                        required
                        placeholder='Your text here'
                        className="feedback-textarea"
                        value="Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ac a, porttitor ac arcu morbi bibendum interdum non. Nisi etiam posuere orci lacus neque Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ac a, porttitor ac arcu morbi bibendum interdum non. Nisi etiam posuere orci lacus neque Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ac a, porttitor ac arcu morbi bibendum interdum non. Nisi etiam posuere orci lacus neque Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ac a, porttitor ac arcu morbi bibendum interdum non. Nisi etiam posuere orci lacus neque Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ac a, porttitor ac arcu morbi bibendum interdum non. Nisi etiam posuere orci lacus neque " />
                </div>
                <div className="modal-footer">
                    <button className="cancel-btn"  >
                        Cancel
                    </button>
                    <button className="confirm-btn"  >
                        Create
                    </button>
                </div>
            </div>
        </div>
    );
};

export default CourseMaterial;